<template>
  <div>
    <ProjectList />
    <VersionDisplayer
      v-if="!openPopin"
      @close-popin="hasBeenClosed = true"
      class="version-popin"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import ProjectList from '@/components/Projects/ProjectList.vue';
import VersionDisplayer from '@/components/VersionDisplayer.vue';
import _cookie from '@/helpers/cookieHelper';

@Component({
  components: {
    ProjectList,
    VersionDisplayer
  }
})
export default class Home extends Vue {
  private hasBeenClosed: boolean = false;

  private upToDate = _cookie.getCookie('version') === process.env.VITE_VERSION;

  get openPopin() {
    return this.upToDate || this.hasBeenClosed;
  }
}
</script>
<style lang="stylus">
.version-popin{
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
</style>
